import React from 'react';
import { CreditCardIcon } from 'lucide-react';
export const CHECKOUT_URL = 'https://vancesimple.com/cart/51220922433703:1';
type CtaButtonProps = {
  label?: string;
  size?: 'md' | 'lg';
  className?: string;
  href?: string;
};
export function CtaButton({
  label = '¡QUIERO MI CRÉDITO LIMPIO AHORA!',
  size = 'lg',
  className = '',
  href = CHECKOUT_URL
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'w-full sm:w-auto px-5 py-3.5 text-[0.9rem] sm:px-8 sm:py-5 sm:text-base' : 'px-4 py-2.5 text-xs';
  return <a href={href} target="_blank" rel="noopener noreferrer" className={`group inline-flex items-center justify-center gap-2 rounded-lg bg-gold text-center font-bold uppercase leading-tight tracking-wide text-navy-deep shadow-lift outline-none transition-[transform,background-color,box-shadow] duration-150 ease-smooth hover:bg-gold-light focus-visible:ring-4 focus-visible:ring-gold/40 active:translate-y-px ${sizing} ${className}`} data-id="element-30" data-mp="lkxryfkylmoo">
      <CreditCardIcon className={size === 'lg' ? 'h-4 w-4 shrink-0 sm:h-5 sm:w-5' : 'h-4 w-4 shrink-0'} aria-hidden="true" data-id="element-31" data-mp="35xxsmqt5qpta" />
      <span data-id="element-32" data-mp="3a0u3fvcghhmo">{label}</span>
    </a>;
}